import { render, staticRenderFns } from "./UserReport.vue?vue&type=template&id=7664e415&scoped=true&lang=pug"
import script from "./UserReport.vue?vue&type=script&lang=js"
export * from "./UserReport.vue?vue&type=script&lang=js"
import style0 from "./UserReport.vue?vue&type=style&index=0&id=7664e415&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7664e415",
  null
  
)

export default component.exports